import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Terms from "./components/pages/Terms";
import Privacy from "./components/pages/Privacy";
import Verify from "./components/pages/Verify";

// Pages
const Hometwo = React.lazy(() => import("./components/pages/Hometwo"));
const About = React.lazy(() => import("./components/pages/About"));
const Error = React.lazy(() => import("./components/pages/Error"));
const Shop = React.lazy(() => import("./components/pages/Shop"));
const Productsingle = React.lazy(() =>
  import("./components/pages/Productsingle")
);
const Cart = React.lazy(() => import("./components/pages/Cart"));
const Checkout = React.lazy(() => import("./components/pages/Checkout"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const Report = React.lazy(() => import("./components/pages/Report"));

function App() {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route exact path="/" component={Hometwo} />
          <Route path="/about" component={About} />
          <Route path="/error" component={Error} />
          <Route path="/shop" component={Shop} />
          <Route path="/product" component={Productsingle} />
          <Route path="/cart" component={Cart} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/contact" component={Contact} />
          <Route path="/verify" component={Verify} />
          <Route path="/terms" component={Terms} />
          <Route path="/privacy" component={Privacy} />
          <Route path="/report" component={Report} />


        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
